import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CommandResult } from "../../../../shared/_types/command-result.type";

@Injectable({
    providedIn: "root",
})
export class PricingPackagesService {
    constructor(private http: HttpClient) {}

    list(): Observable<PricingPackage[]> {
        return this.http.get<PricingPackage[]>("/pricing-packages");
    }

    get(id: string): Observable<PricingPackage> {
        return this.http.get<PricingPackage>(`/pricing-packages/${id}`);
    }

    create(pricingPackage: PricingPackage): Observable<PricingPackage> {
        return this.http.post<PricingPackage>("/pricing-packages", pricingPackage);
    }

    update(id: string, pricingPackage: PricingPackage): Observable<PricingPackage> {
        return this.http.put<PricingPackage>(`/pricing-packages/${id}`, pricingPackage);
    }

    delete(id: string): Observable<CommandResult> {
        return this.http.delete<CommandResult>(`/pricing-packages/${id}`);
    }
}

export type PricingPackage = {
    id?: string;
    name: string;
    isHidden: boolean;
    type: PricingPackageType;
    externalId?: string;
    description?: string;
    comment?: string;
    connectedBrokerAccountsLimit?: number;
    testRunsPerDayLimit?: number;
    assetsPerTestRunLimit?: number;
    activeBotsLimit?: number;
    customListLengthLimit?: number;
    customListsCountLimit?: number;
    conditionalOrdersLimit?: number;
    botRunsPerDayLimit?: number;
    instantRunsPerDayLimit: number;
    botsPerBrokerAccountLimit?: number;
    isMarketplaceAvailable?: boolean;
    areStandardListsAvailable?: boolean;
    isWhiteHatBotsPaperAccountAvailable?: boolean;
    isAlpacaPaperAccountAvailable?: boolean;
    isAlpacaLiveAccountAvailable?: boolean;
    isWebullSandboxAccountAvailable?: boolean;
    isWebullLiveAccountAvailable?: boolean;
    isPublicSandboxAccountAvailable?: boolean;
    isPublicLiveAccountAvailable?: boolean;
};

export enum PricingPackageType {
    Free = 0,
    Trial = 1,
    Subscription = 2,
    SubscriptionAddon = 3,
    OneTimeAddon = 4,
}

export const DEFAULT_PACKAGE: PricingPackage = {
    name: "New Package",
    isHidden: false,
    type: PricingPackageType.Subscription,
    connectedBrokerAccountsLimit: 1,
    testRunsPerDayLimit: 5,
    assetsPerTestRunLimit: 10,
    activeBotsLimit: 1,
    customListLengthLimit: 5,
    customListsCountLimit: 1,
    conditionalOrdersLimit: 5,
    botRunsPerDayLimit: 5,
    instantRunsPerDayLimit: 0,
    isMarketplaceAvailable: false,
    areStandardListsAvailable: false,
    isWhiteHatBotsPaperAccountAvailable: false,
    isAlpacaPaperAccountAvailable: false,
    isAlpacaLiveAccountAvailable: false,
    isWebullSandboxAccountAvailable: false,
    isWebullLiveAccountAvailable: false,
    isPublicSandboxAccountAvailable: false,
    isPublicLiveAccountAvailable: false,
};
